import{Radio}from"antd";import Modal from"@wp/src/components/common/modal";import styled from"@emotion/styled";import{Link}from"@wp/src/components/common/";import{AccountDeletionReason,AccountDeletionStep}from"./types";export const StyledRadio=styled(Radio)`
  line-height: 20px;
`;export const StyledRadioGroup=styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  gap: 10px;
`;export const MainText=styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;export const StyledModal=styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }

  max-width: ${props=>{switch(props.selectedOption){case AccountDeletionReason.SecurityConcerns:case AccountDeletionReason.SomethingNotWorking:case AccountDeletionReason.ProductAdvantagesUnclear:case AccountDeletionReason.Other:return props.step===AccountDeletionStep.ReasonSelected?"480px":"400px";default:return"400px"}}};
`;export const StyledListItem=styled.li`
  font-weight: 600;
`;export const SyledList=styled.ul`
  margin-top: 0;
  margin-left: 20px;
  padding-left: 0;
`;export const InputBoxTitle=styled.div`
  font-size: 14px;
  padding-bottom: 4px;
`;export const StyledLink=styled(Link)`
  font-size: inherit;
  padding: 0;
  font-weight: 600;
`;